<template>
  <div class="nav-bar-item">
    <div v-if="loginIn" class="wx-code-popover">
      <el-popover
        :placement="placement"
        :width="width"
        :trigger="trigger">
        <div class="wx-img">
          <el-image
            class="img"
            :src="codeUrl"
          />
          <div class="content">{{ content }}</div>
        </div>
        <slot name="reference" slot="reference">
          <div class="icon-text">车务助手小程序</div>
        </slot>
      </el-popover>
    </div>
    <div v-else class="wx-code-popover_login">
      <el-popover
        :placement="placement"
        :width="width"
        :trigger="trigger"
        offset='-100'>
        <div class="wx-img">
          <el-image
            class="img"
            :src="codeUrl"
          />
          <div class="content">{{ content }}</div>
        </div>
        <div name="reference" slot="reference">
          <div class="icon-text icon-text-login">小程序</div>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WxCodePopover',
  props: {
    loginIn: {
      type: Boolean,
      default: true,
    },
    codeUrl: {
      type: String,
      default: require('@/assets/img/QRCode.png'),
    },
    content: {
      type: String,
      default: '微信扫一扫 使用小程序',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    width: {
      type: String,
      default: '136px',
    },
  },
  data() {
    return {
    }
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
.wx-code-popover {
  margin-left: 0;
  background-image: url('../../assets/img/xiaochengxu.png');
  background-size: 11%;
  background-repeat: no-repeat;
  background-position: 8px 2px;
  &:hover{
    color: #276BEC;
    background-image: url('../../assets/img/xiaochengxu-h.png');
    background-size: 11%;
    background-repeat: no-repeat;
    background-position: 8px 2px;
  }
}
.wx-code-popover_login {
  cursor: pointer;
  color: #999;
  position: fixed;
  right: 10px;
  bottom: 100px;
  width: 48px;
  height: 75px;
  border-radius: 100px;
  background-color: #fff;
  margin-left: 0;
}
::v-deep .el-popover__reference-wrapper {
  width: 144px;
  margin-left: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
::v-deep .el-popover {
  min-width: 136px;
}
.wx-img {
  display: flex;
  flex-flow: column;
  align-items: center;
  .img {
    width: 160px;
    height: 160px;
    padding-bottom: 10px;
  }
  .content {
    font-size: 12px;
    color: #3D3D3D;
  }
}
.icon-text {
  font-size: 14px;
}
.icon-text-login{
  border-radius: 100px;
  width: 45px;
  position: absolute;
  left: 5%;
  top: 0%;
  height: 70px;
  line-height: 100px;
  background-image: url('../../assets/img/xiaochengxu.png');
  background-size: 65%;
  background-repeat: no-repeat;
  background-position: 8px 7px;
  &:hover{
    color: #276BEC;
    background-image: url('../../assets/img/xiaochengxu-h.png');
    background-size: 65%;
    background-repeat: no-repeat;
    background-position: 8px 7px;
  }
}
</style>
